<app-widget [widget-meta]="this.data"
  hidehelp="true">
  @if (myEquipment.data$ | async; as equipment) {
    <div>
      <div class="pb-3">
        <strong>All listed equipment is property of the state of North Carolina.  It is the responsibility of the assignee to ensure their assigned equipment is properly returned to the Kenan-Flagler IT Department when it is no longer in use.</strong>
      </div>
      <div class="row col-12">
        <div class="col-md-12 col-lg-6">
          <!--  ASSIGNED EQUIPMENT -->
          <div class="card">
            <div class="card-header h6">Assigned Equipment</div>
            <div class="card-body pt-0">
              @if (equipment.assigned == null) {
                <p>No equipment was found in SolarWinds.</p>
              }
              @if (equipment.assigned != null) {
                @for (group of equipment.assigned?.Computers | keyvalue; track group) {
                  <solarwinds-equipment [group]="group.key" [items]="group.value"></solarwinds-equipment>
                }
                @for (group of equipment.assigned?.Assets | keyvalue; track group) {
                  <solarwinds-equipment [group]="group.key" [items]="group.value"></solarwinds-equipment>
                }
              }
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6">
          <!--  DEPARTMENTAL EQUIPMENT -->
          @if (equipment.departmental != null) {
            <div class="card">
              <div class="card-header h6">Departmental Equipment</div>
              <div class="card-body pt-0">
                @for (group of equipment.departmental?.Computers | keyvalue; track group) {
                  <solarwinds-equipment [group]="group.key" [items]="group.value"></solarwinds-equipment>
                }
                @for (group of equipment.departmental?.Assets | keyvalue; track group) {
                  <solarwinds-equipment [group]="group.key" [items]="group.value"></solarwinds-equipment>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  } @else {
    <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
  }

  <loading-or-error #loadingOrError
    [loadingWrapper]="myEquipment"
    [errorMessage]="'Oops! Looks like we can\'t get information for My Equipment!'">
  </loading-or-error>

</app-widget>
